import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import {
    getAppVersions as getAppVersionsApi,
    getAppVersionById as getAppVersionByIdApi,
    createAppVersion as createAppVersionApi,
    updateAppVersion as updateAppVersionApi,
    deleteAppVersion as deleteAppVersionApi,
} from 'helpers/api/appVersions';
import { appVersionApiResponseSuccess, appVersionApiResponseError } from './actions';
import { AppVersionActionTypes } from './constants';

/**
 * Fetch all app versions
 */
function* getAppVersions(): SagaIterator {
    try {
        const response = yield call(getAppVersionsApi);
        yield put(appVersionApiResponseSuccess(AppVersionActionTypes.GET_APP_VERSIONS, response.data));
    } catch (error: any) {
        yield put(appVersionApiResponseError(AppVersionActionTypes.GET_APP_VERSIONS, error));
    }
}

/**
 * Fetch single app version by ID
 */
function* getAppVersionById({ payload }: any): SagaIterator {
    try {
        const response = yield call(getAppVersionByIdApi, payload);
        yield put(appVersionApiResponseSuccess(AppVersionActionTypes.GET_APP_VERSION_BY_ID, response.data));
    } catch (error: any) {
        yield put(appVersionApiResponseError(AppVersionActionTypes.GET_APP_VERSION_BY_ID, error));
    }
}

/**
 * Create (upsert) app version
 */
function* createAppVersion({ payload }: any): SagaIterator {
    try {
        const response = yield call(createAppVersionApi, { data: payload });
        yield put(appVersionApiResponseSuccess(AppVersionActionTypes.CREATE_APP_VERSION, response.data));
    } catch (error: any) {
        yield put(appVersionApiResponseError(AppVersionActionTypes.CREATE_APP_VERSION, error));
    }
}

/**
 * Update app version
 */
function* updateAppVersion({ payload }: any): SagaIterator {
    try {
        const { id, data } = payload;
        const response = yield call(updateAppVersionApi, { id, data });
        yield put(appVersionApiResponseSuccess(AppVersionActionTypes.UPDATE_APP_VERSION, response.data));
    } catch (error: any) {
        yield put(appVersionApiResponseError(AppVersionActionTypes.UPDATE_APP_VERSION, error));
    }
}

/**
 * Delete app version
 */
function* deleteAppVersion({ payload }: any): SagaIterator {
    try {
        yield call(deleteAppVersionApi, payload);
        yield put(appVersionApiResponseSuccess(AppVersionActionTypes.DELETE_APP_VERSION, payload.id));
    } catch (error: any) {
        yield put(appVersionApiResponseError(AppVersionActionTypes.DELETE_APP_VERSION, error));
    }
}

// ─── Watchers ───────────────────────────────────────────────────────────────

export function* watchGetAppVersions() {
    yield takeEvery(AppVersionActionTypes.GET_APP_VERSIONS, getAppVersions);
}

export function* watchGetAppVersionById() {
    yield takeEvery(AppVersionActionTypes.GET_APP_VERSION_BY_ID, getAppVersionById);
}

export function* watchCreateAppVersion() {
    yield takeEvery(AppVersionActionTypes.CREATE_APP_VERSION, createAppVersion);
}

export function* watchUpdateAppVersion() {
    yield takeEvery(AppVersionActionTypes.UPDATE_APP_VERSION, updateAppVersion);
}

export function* watchDeleteAppVersion() {
    yield takeEvery(AppVersionActionTypes.DELETE_APP_VERSION, deleteAppVersion);
}

// ─── Root saga ───────────────────────────────────────────────────────────────

function* appVersionSaga() {
    yield all([
        fork(watchGetAppVersions),
        fork(watchGetAppVersionById),
        fork(watchCreateAppVersion),
        fork(watchUpdateAppVersion),
        fork(watchDeleteAppVersion),
    ]);
}

export default appVersionSaga;
